import { createContext, useContext } from 'react';
import type { Me } from '@/api/session';

export const MeContext = createContext<Me | null>(null);

export function useMeOrThrow(): Me {
  const me = useContext(MeContext);
  if (!me) throw new Error('useMeOrThrow outside the shell');
  return me;
}
